import { render, staticRenderFns } from "./QIconButton.vue?vue&type=template&id=52ed7dea&scoped=true"
import script from "./QIconButton.vue?vue&type=script&lang=js"
export * from "./QIconButton.vue?vue&type=script&lang=js"
import style0 from "./QIconButton.vue?vue&type=style&index=0&id=52ed7dea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ed7dea",
  null
  
)

export default component.exports